import VTHOSupply from './VTHOSupply';

export function App() {
  return (
    <>
      <VTHOSupply />
    </>
  )
}